import { Injectable, inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class ShareService {
  private snackBar = inject(MatSnackBar);
  private router = inject(Router);
  /**
   * Returns a full referral URL for the given user and code.
   */
  getReferralLink(referralCode: string): string {
    // Use router to build the relative path; prepend origin for full link.
    const origin = typeof window !== 'undefined' ? window.location.origin : '';
    const relative = this.router.createUrlTree(['/models/join', referralCode]).toString();
    return origin + relative;
  }

  /**
   * Returns the QR code data 
   */
  getQrCodeData(referralCode: string): string {
    return this.getReferralLink(referralCode);
  }

  /**
   * Copies the given text to the clipboard.
   */
  copyToClipboard(text: string): void {
    const show = (msg: string) => this.snackBar.open(msg, 'Close', { duration: 2500 });
    if (typeof navigator !== 'undefined' && navigator.clipboard) {
      navigator.clipboard.writeText(text)
        .then(() => show('Referral link copied'))
        .catch(err => {
          console.error('Clipboard copy failed', err);
          show('Copy failed');
        });
      return;
    }
    // Fallback
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();
    try {
      document.execCommand('copy');
      show('Referral link copied');
    } catch (err) {
      console.error('Fallback clipboard copy failed', err);
      show('Copy failed');
    }
    document.body.removeChild(textarea);
  }

  /**
   * Shares the referral link using the Web Share API if available, otherwise copies to clipboard.
   */
  async shareLink(referralLink: string): Promise<void> {
    const show = (msg: string) => this.snackBar.open(msg, 'Close', { duration: 2500 });
    if (typeof navigator !== 'undefined' && navigator.share) {
      try {
        await navigator.share({
          title: 'Join me!',
          text: 'Sign up using my referral link:',
          url: referralLink
        });
        show('Share dialog opened');
      } catch (err: any) {
        if (err && err.name === 'AbortError') {
          // User cancelled; no message necessary
          return;
        }
        console.warn('Share failed', err);
        show('Share failed; link copied');
        this.copyToClipboard(referralLink);
      }
    } else {
      this.copyToClipboard(referralLink);
    }
  }
}
